import { Link } from 'react-router';
import { Button } from '@/components/ui/button';

interface CTAButtonProps {
  to?: string;
  buttonText?: string | React.ReactNode;
  microcopy?: string;
  size?: 'default' | 'sm' | 'lg' | 'icon';
  variant?: 'default' | 'outline' | 'ghost' | 'link' | 'destructive' | 'secondary';
  className?: string;
  event?: string;
  onClick?: () => void | Promise<void>;
}

const CTAButton = ({
  to = "/?auth=signup",
  buttonText = "Start Writing Now",
  microcopy = "7-Day Free Trial • Cancel Anytime",
  size = 'lg',
  variant = 'default',
  className = '',
  event = 'CTA Clicked',
  onClick
}: CTAButtonProps) => {
  const handleClick = () => {
    if (typeof window !== 'undefined' && window.plausible) {
      window.plausible(event);
    }
    onClick?.();
  };

  return (
    <div className="space-y-4">
      <Button
        size={size}
        variant={variant}
        className={`transition-all ${className}`}
        asChild
      >
        <Link to={to || ""} onClick={handleClick}>
          {buttonText}
        </Link>
      </Button>
      {microcopy && (
        <p className="text-sm text-center text-muted-foreground">
          {microcopy}
        </p>
      )}
    </div>
  );
};

export default CTAButton;
